<app-loaderlight
  class="loader"
  [ngStyle]="{ display: displayStyles }"
></app-loaderlight>
<div class="blue outer-container">
  <!-- <app-navbar></app-navbar> -->
  <!-- <app-dash-nav></app-dash-nav> -->

  <div class="white inner-container">
    <h1 style="color: black">E-Cell IIT Bombay welcomes you to Eureka! 2024</h1>
    <h3 style="color: var(--primary-blue); font-weight: 600">
      Please complete all the steps to have your entry to Eureka! 2024
      considered
    </h3>
    <mat-horizontal-stepper
      style="background: transparent"
      [linear]="isLinear"
      [selectedIndex]="1"
      #stepper
    >
      <!-- <mat-horizontal-stepper #stepper> -->
      <!-- <mat-step [stepControl]="firstFormGroup">
    <form [formGroup]="firstFormGroup"  class="blue main-form">
      <ng-template matStepLabel>Register</ng-template>
      <h3>Complete Your Details</h3>
      <br>
      <mat-form-field  class="input-field">
        <mat-label class="input-label"> Full Name</mat-label>
        <input matInput placeholder="Name" formControlName="name" required>
      </mat-form-field><br>
      <mat-form-field  class="input-field">
        <mat-label class="input-label">Email ID</mat-label>
        <input matInput placeholder="Email" formControlName="email" required>
      </mat-form-field>
      <br>
      <mat-form-field  class="input-field">
        <mat-label class="input-label">Contact Number</mat-label>
        <input matInput placeholder="Contact" formControlName="contact" required>
      </mat-form-field>
      <br/>
      <mat-form-field class="input-field">
        <mat-label class="input-label">Gender</mat-label>
        <mat-select formControlName="gender">
          <mat-option *ngFor="let gender of gender" [value]="gender.value">
            {{ gender.viewValue }}
          </mat-option>
        </mat-select>
      </mat-form-field><br>
      <mat-form-field  class="input-field">
        <mat-label class="input-label">Set Password for your team</mat-label>
        <input matInput placeholder="Password" formControlName="password" required>
      </mat-form-field>
      <br>
      <mat-form-field class="input-field">
        <mat-label class="input-label">From where did you hear about Eureka! 2022?*</mat-label>
        <mat-select formControlName="source">
          <mat-option *ngFor="let gender of gender" [value]="gender.value">
            {{ gender.viewValue }}
          </mat-option>
        </mat-select>
      </mat-form-field><br>
      <mat-form-field  class="input-field">
        <mat-label class="input-label">Referral ID (If any)</mat-label>
        <input matInput placeholder="Referral ID" formControlName="referral" required>
      </mat-form-field>
      <div>
        <button class="green-button" mat-button matStepperNext>Next</button>
      </div>
    </form>
  </mat-step> -->

      <!-- <mat-step [stepControl]="secondFormGroup">
    <form [formGroup]="secondFormGroup" class="blue main-form">
      <ng-template matStepLabel>Complete Your Details</ng-template>
      <mat-form-field class="input-field">
        <mat-label class="input-label">Current professional status?</mat-label>
        <mat-select formControlName="status">
          <mat-option *ngFor="let gender of status" [value]="gender.value">
            {{ gender.viewValue }}
          </mat-option>
        </mat-select>
      </mat-form-field><br>
      <mat-form-field  class="input-field">
        <mat-label class="input-label">Institute/Workplace</mat-label>
        <input matInput placeholder="Institute" formControlName="institute" required>
      </mat-form-field>
      <br/>
      <mat-form-field class="input-field">
        <mat-label class="input-label">Country</mat-label>
        <mat-select formControlName="country">
          <mat-option *ngFor="let country of country" [value]="country.value">
            {{ country.viewValue }}
          </mat-option>
        </mat-select>
      </mat-form-field><br>
      <mat-form-field class="input-field">
        <mat-label class="input-label">State</mat-label>
        <mat-select formControlName="state">
          <mat-option *ngFor="let state of states" [value]="state.value">
            {{ state.viewValue }}
          </mat-option>
        </mat-select>
      </mat-form-field><br>
      <mat-form-field  class="input-field">
        <mat-label class="input-label">City</mat-label>
        <input matInput placeholder="City" formControlName="city" required>
      </mat-form-field>
      <br/>
      <mat-form-field class="input-field">
        <mat-label class="input-label">Do you want to register in PAN IIT track?</mat-label>
        <mat-select formControlName="pan">
          <mat-option *ngFor="let bool of bool" [value]="bool.value">
            {{ bool.viewValue }}
          </mat-option>
        </mat-select>
      </mat-form-field><br>
      <h5>*For the teams with 50% IITians, we have introduced PAN IIT track to bring all IIT startups under one roof!
      </h5>

      <div>
        <button class="green-button" mat-button matStepperPrevious>Back</button>
        <button (click)="next1()" class="green-button" mat-button matStepperNext>Next</button>
      </div>
    </form>
  </mat-step> -->
      <mat-step [completed]="true" [editable]="false" state="CONFIRMED">
        <ng-template matStepLabel>Personal Details</ng-template>
      </mat-step>
      <mat-step [stepControl]="thirdFormGroup" [editable]="!basicFilled.value">
        <form [formGroup]="thirdFormGroup">
          <ng-template matStepLabel>Team Details</ng-template>
          <div class="form-cards">
            <div class="card" *ngFor="let lis of lis; let i = index">
              <h4>Team Member {{ i + 1 }}</h4>
              <img src="assets/images/profile.png" alt="" />
              <h4>{{ lis.name }}</h4>
              <!-- <h4>Position</h4> -->
            </div>

            <div class="card" (click)="openPopup2()">
              <!-- <h4>Team Member 1</h4> -->
              <img
                style="margin-top: 50px"
                src="assets/images/plus.png"
                alt=""
              />
              <h4>Add Member</h4>
              <!-- <h4>Position</h4> -->
            </div>
          </div>
          <div>
            <button class="btn btn-lg inverse" mat-button matStepperNext>
              Next
            </button>
          </div>
        </form>
      </mat-step>

      <mat-step [stepControl]="basicFilled" [editable]="!basicFilled.value">
        <ng-template matStepLabel>Idea Submission</ng-template>
        <!-- <p style="color: white">You are now done.</p> -->

        <form [formGroup]="fourthFormGroup" class="blue main-form">
          <mat-form-field class="input-field" appearance="outline">
            <input
              matInput
              placeholder="Startup Name*"
              formControlName="startup"
              required
            />
            <mat-error
              *ngIf="fourthFormGroup.controls['startup'].hasError('required')"
            >
              Startup Name is required!
            </mat-error> </mat-form-field
          ><br />
          <mat-form-field class="input-field" appearance="outline">
            <mat-select formControlName="sector1" placeholder="Sector 1*">
              <mat-option *ngFor="let sector of sector" [value]="sector.value">
                {{ sector.viewValue }}
              </mat-option>
            </mat-select>
            <mat-error
              *ngIf="fourthFormGroup.controls['sector1'].hasError('required')"
            >
              Sector is required!
            </mat-error> </mat-form-field
          ><br />
          <mat-form-field class="input-field" appearance="outline">
            <mat-select formControlName="sector2" placeholder="Sector 2*">
              <mat-option *ngFor="let sector of sector" [value]="sector.value">
                {{ sector.viewValue }}
              </mat-option>
            </mat-select>
            <mat-error
              *ngIf="fourthFormGroup.controls['sector2'].hasError('required')"
            >
              Sector is required!
            </mat-error>
          </mat-form-field>
          <br />
          <!-- <mat-form-field class="input-field" appearance="outline">
            <mat-select
              formControlName="registered"
              placeholder="Is your idea DPIIT registered?*"
            >
              <mat-option *ngFor="let bool of bool" [value]="bool.value">
                {{ bool.viewValue }}
              </mat-option>
            </mat-select>
            <mat-error
              *ngIf="
                fourthFormGroup.controls['registered'].hasError('required')
              "
            >
              This field is required!
            </mat-error> </mat-form-field
          ><br />
          <mat-form-field
            class="input-field"
            appearance="outline"
            *ngIf="
              fourthFormGroup.controls['registered']?.value == bool[0].value
            "
          >
            <input
              matInput
              placeholder="DPIIT Number (optional)"
              formControlName="dpiit"
            /> </mat-form-field
          ><br
            *ngIf="
              fourthFormGroup.controls['registered']?.value == bool[0].value
            "
          /> -->
          <mat-form-field class="input-field" appearance="outline">
            <textarea
              matInput
              name="idea"
              placeholder="Idea Description*"
              formControlName="idea"
              required
            ></textarea>
            <mat-error
              *ngIf="fourthFormGroup.controls['idea'].hasError('required')"
            >
              Idea Description is required!
            </mat-error>
          </mat-form-field>
          <br />
          <!-- <mat-form-field class="input-field" appearance="outline">
            <mat-select
              formControlName="registered"
              placeholder="Add Track*"
            >
              <mat-option *ngFor="let bool of bool" [value]="bool.value">
                {{ bool.viewValue }}
              </mat-option>
            </mat-select>
            <mat-error
              *ngIf="
                fourthFormGroup.controls['registered'].hasError('required')
              "
            >
              This field is required!
            </mat-error> </mat-form-field> -->
            
          <!-- <mat-form-field class="input-field" appearance="outline">
            <mat-select formControlName="track" placeholder="Add Track*">
              <mat-option *ngFor="let track of tracks" [value]="track.value">
                {{ track.viewValue }}
              </mat-option>
            </mat-select>
            <mat-error
              *ngIf="fourthFormGroup.controls['track'].hasError('required')"
            >
              This field is required!
            </mat-error>
          </mat-form-field> -->

          <div>
            <button
              class="btn inverse"
              style="width: auto"
              mat-button
              matStepperPrevious
            >
              Back
            </button>
            <!-- <button
              class="btn inverse"
              style="width: auto"
              mat-button
              (click)="skip()"
            >
              Skip for now
            </button> -->
            <button
              class="btn inverse"
              style="width: auto"
              mat-button
              (click)="submit()"
            >
              Submit
            </button>
          </div>
        </form>
      </mat-step>

      <mat-step>
        <ng-template matStepLabel>Questionnaire Filling</ng-template>

        <ng-template matStepContent>
          <app-ideas-inner
            (isFinished)="submitQuestionnaire()"
            (isLoading)="toggleLoaderDisplay($event)"
          ></app-ideas-inner>
        </ng-template>
      </mat-step>
    </mat-horizontal-stepper>
  </div>
</div>
<div style="background: #04070a">
  <app-footer></app-footer>
</div>

<!-- MODAL2 -->
<!--   ADD TEAM MEMBER    -->

<div
  style="z-index: 1"
  class="modal"
  tabindex="-1"
  role="dialog"
  [ngStyle]="{ display: displayStyle2 }"
>
  <div class="modal-dialog" role="document">
    <div
      class="modal-content mode"
      style="border: 1px solid black; border-radius: 0"
    >
      <div class="modal-header">
        <div style="float: right; color: white">
          <img
            src="https://eureka2022.s3.ap-south-1.amazonaws.com/close.png"
            alt="close"
            (click)="closePopup2()"
          />
        </div>
        <h1
          style="
            display: flex;
            justify-content: center;
            align-items: center;
            margin-bottom: 0rem;
            margin-top: 2rem;
          "
          class="modal-title"
        >
          <!-- <i
            class="fa fa-circle"
            style="font-size: small; color: #00c4f4"
            aria-hidden="true"
          ></i> -->
          <span class="headi">ADD A MEMBER</span>
          <!-- <i
            class="fa fa-circle"
            style="font-size: small; color: #00c4f4"
            aria-hidden="true"
          ></i> -->
        </h1>
      </div>
      <div>
        <form [formGroup]="firstFormGroup" class="mode main-form2">
          <mat-form-field class="input-field" appearance="outline">
            <input
              matInput
              placeholder="Full Name*"
              formControlName="name"
              required
            />
            <mat-error
              *ngIf="firstFormGroup.controls['name'].hasError('required')"
            >
              Name is required!
            </mat-error> </mat-form-field
          ><br />
          <mat-form-field class="input-field" appearance="outline">
            <input
              matInput
              placeholder="Email ID*"
              name="email"
              pattern="[a-zA-Z0-9.-_]{1,}@[a-zA-Z.-]{2,}[.]{1}[a-zA-Z]{2,}"
              formControlName="email"
              required
            />
            <mat-error
              *ngIf="firstFormGroup.controls['email'].hasError('required')"
            >
              Email is required!
            </mat-error>
            <mat-error
              *ngIf="firstFormGroup.controls['email'].hasError('email')"
            >
              Email is not Valid!
            </mat-error>
          </mat-form-field>
          <br />
          <!-- <mat-form-field class="input-field" appearance="outline">
            <mat-select formControlName="state" placeholder="State*">
              <mat-option *ngFor="let state of states" [value]="state.value">
                {{ state.viewValue }}
              </mat-option>
            </mat-select> </mat-form-field -->
          <!-- <br /> -->
          <!-- <mat-form-field class="input-field" appearance="outline">
            <input
              matInput
              placeholder="City*"
              formControlName="city"
              required
            />
            <mat-error
              *ngIf="firstFormGroup.controls['city'].hasError('required')"
            >
              City is required!
            </mat-error>
          </mat-form-field> -->
          <!-- <br /> -->
          <mat-form-field class="input-field" appearance="outline">
            <input
              matInput
              placeholder="Contact Number*"
              name="contact"
              pattern="[0-9+]{10,10}"
              formControlName="contact"
              required
            />
            <mat-error
              *ngIf="firstFormGroup.controls['contact'].hasError('required')"
            >
              Mobile is required!
            </mat-error>
            <mat-error
              *ngIf="firstFormGroup.controls['contact'].hasError('min')"
            >
              Mobile No is Wrong!
            </mat-error>
          </mat-form-field>
          <br />
          <mat-form-field class="input-field" appearance="outline">
            <mat-select formControlName="gender" placeholder="Gender*">
              <mat-option *ngFor="let gender of gender" [value]="gender.value">
                {{ gender.viewValue }}
              </mat-option>
            </mat-select> </mat-form-field
          ><br />
          <!-- <mat-form-field class="input-field" appearance="outline">
            <mat-select
              formControlName="status"
              placeholder="Current professional status?"
            >
              <mat-option *ngFor="let gender of status" [value]="gender.value">
                {{ gender.viewValue }}
              </mat-option>
            </mat-select> </mat-form-field
          ><br /> -->
          <div>
            <button
              class="green-button"
              [disabled]="btnDisabled"
              mat-button
              (click)="nexts2($event)"
            >
              {{ btnText }}
            </button>
          </div>
        </form>
      </div>
      <div class="modal-footer"></div>
    </div>
  </div>
</div>
